// index.ts ( Directives Index File )
// =========================================
import { AlTabAccessibilityDirective } from './tab-accessibility.directive';

// Export All Directives
// ================================
export { AlTabAccessibilityDirective } from './tab-accessibility.directive';

export const AL_CORE_DIRECTIVES: any = [
    // List all your directives here
    AlTabAccessibilityDirective
];
